import React from 'react';
import { connect } from 'react-redux';
import { selectAllAssignment } from 'actions/assignmentActivity/assignment_action';

const Header = ({ hideSelect, checkedCount, selectAll }) => {
  return (
    <thead>
      <tr>
        <th className="SelecTable-select">
          <input
            type="checkbox"
            id="select-all"
            className="SelecTable-toggleAll"
            checked={checkedCount > 0}
            name="select_all"
            onChange={e => selectAll(e.target.checked)}
            aria-label={t('actions.bulk')}
          />
        </th>
        <th className="AssignmentsTable-status" />
        <th className="DataTable-name AssignmentsTable-assignee ">
          {t('assignments.assignee')}
        </th>
        <th className="DataTable-name AssignmentsTable-assignable">
          {t('assignments.singular')}
        </th>
        <th className="AssignmentsTable-dueDate">{t('assignments.due')}</th>
        <th className="AssignmentsTable-startedAt">{t('progress.started')}</th>
        <th className="AssignmentsTable-progress">{t('assignments.title')}</th>
        <th className="AssignmentsTable-completedAt">
          {t('assignments.completed.label')}
        </th>
        <th className="AssignmentsTable-attempts">
          {t('assignments.attempts')}
        </th>
        <th className="AssignmentsTable-score">
          {t('gradebook.export.score')}
        </th>
        <th
          className={`${
            hideSelect ? 'DataTable-actions' : 'DataTable-actionsRow'
          }`}
        />
      </tr>
    </thead>
  );
};

const mapStateToProps = state => ({
  checkedCount: state.assignDirectly.checkedCount,
});

const mapDispatchToProps = dispatch => ({
  selectAll(checked) {
    dispatch(selectAllAssignment(checked));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
